import { useAuth } from "@/hooks/useAuth";

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-foreground font-display">Settings</h1>
        <p className="text-muted-foreground text-sm mt-1">Manage your account</p>
      </div>

      <div className="rounded-lg border border-border bg-card p-8 space-y-4">
        <div>
          <p className="text-sm text-muted-foreground">Email</p>
          <p className="text-foreground">{user?.email}</p>
        </div>
        <p className="text-sm text-muted-foreground italic">
          More settings coming soon.
        </p>
      </div>
    </div>
  );
}
